// extracted by mini-css-extract-plugin
export default {"Credit":"Credit_Credit__68k+-","loading":"Credit_loading__luMtR"};